import { COLORS } from '@constants';
import { Typography } from '@ui';
import styled from 'styled-components';

export const InviteCard = styled.div`
    background: ${COLORS.$white};
    border: 1px solid ${COLORS.$gray15Black};
    border-radius: 8px;
    padding: 32px 24px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
`;

export const InviteCardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: flex-start;
`;

export const InviteCardTitle = styled(Typography.Title)`
    &&& {
        font-size: 20px;
        line-height: 28px;
        font-weight: 500;
        color: ${COLORS.$gray100Black};
        margin: 0;
    }
`;

export const InviteCardDescription = styled(Typography.Text)`
    &&& {
        font-size: 16px;
        line-height: 24px;
        color: ${COLORS.$gray60Black};
    }
`;
